import { render } from "./IconExternalCredit.vue?vue&type=template&id=d4f7287c"
import script from "./IconExternalCredit.vue?vue&type=script&lang=js"
export * from "./IconExternalCredit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconExternalCredit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4f7287c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4f7287c', __exports__)) {
    api.reload('d4f7287c', __exports__)
  }
  
  module.hot.accept("./IconExternalCredit.vue?vue&type=template&id=d4f7287c", () => {
    api.rerender('d4f7287c', render)
  })

}


export default __exports__